<template>
    <div :id="random_id" :class="twMerge('flex flex-wrap justify-center items-baseline', props.appendClass)" :style="`gap: ${cardsGap}px`">
      <div v-for="item in data">
        <div class="p-[1.2px] mb-2.5 rounded-md"
          :class="twMerge('bg-[linear-gradient(180deg,_#E6F3FF_0%,_#FFFFFF_100%)] shadow-md max-w-max mx-auto', props.borderClass)">
          <NuxtLink :to="item.redirectUrl" class="rounded-md block"
            :class="twMerge('p-4 bg-[linear-gradient(225deg,_#FFFFFF_-0.2%,_#F1F8FF_99.8%)]', props.bgClass)">
            <TsImage :src="item.image" :alt="item.imageAltText" height="imageWidth" class="mx-auto" :width="imageHeight" loading="lazy"/>
          </NuxtLink>
        </div>
        <TsTypography align="center" append-class="text-black" :variant="textVariant">{{ item.title }}
        </TsTypography>
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
  import { onMounted, ref } from "vue";
  import { useRandomUUID } from "~/composables/useRandomUUID";
  import { twMerge } from "tailwind-merge";
  
  const { isMobile } = useDevice()
  
  type Data = {
    id: number;
    title?: string;
    image?: string;
    imageAltText?: string;
    redirectUrl?: string;
  }
  
  type Props = {
    data?: Data[];
    borderClass?: string;
    bgClass?: string;
    dataTestid?: string;
    appendClass?: string;
    variant?: string;
    textVariant: 'sm' | 'base' | 'lg';
    imageWidth?: number;
    imageHeight?: number;
    cardsGap: number;
  }
  
  
  //@ts-ignore
  const props = withDefaults(defineProps<Props>(), {
    data: () => [
      {
        id: 1,
        image: '/images/logos/delivery1.svg',
        imageAltText: 'Get up to 50% off',
        title: 'Track Order'
      },
      {
        id: 2,
        image: '/images/logos/pro2.svg',
        imageAltText: 'Get up to 50% off',
        title: 'Pro Card'
      },
      {
        id: 3,
        image: '/images/logos/store.svg',
        imageAltText: 'Get up to 50% off',
        title: 'Store Nearby'
      },
      {
        id: 4,
        image: '/images/logos/bulk.svg',
        imageAltText: 'Get up to 50% off',
        title: 'Bulk Enquiry'
      }
    ],
    imageWidth: 52,
    imageHeight: 52,
    textVariant: 'sm',
    cardsGap: 20,
  });
  
  const random_id = ref("");
  onMounted(() => {
    random_id.value = useRandomUUID();
  });
  
  </script>
  